module.exports = __webpack_public_path__ + "static/media/generated_descriptions.7cbafdb5.txt";